"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var __1 = require("../");
var Alert_1 = __importDefault(require("../Alert"));
function SimpleSnackbar(_a) {
    var info = _a.info, warning = _a.warning, success = _a.success, anchorOrigin = _a.anchorOrigin, onClose = _a.onClose, error = _a.error, _b = _a.autoHideDuration, autoHideDuration = _b === void 0 ? Boolean(error) ? 7000 : 4000 : _b, _c = _a.open, open = _c === void 0 ? Boolean(info) || Boolean(error) || Boolean(warning) || Boolean(success) : _c, rest = __rest(_a, ["info", "warning", "success", "anchorOrigin", "onClose", "error", "autoHideDuration", "open"]);
    var _d = react_1.useState(false), internalOpen = _d[0], setInternalOpen = _d[1];
    var message = info || error || warning || success;
    var severity = info
        ? 'info'
        : error
            ? 'error'
            : warning
                ? 'warning'
                : success
                    ? 'success'
                    : undefined;
    react_1.useEffect(function () {
        setInternalOpen(open);
    }, [open]);
    if (onClose === undefined) {
        onClose = function () { return setInternalOpen(false); };
    }
    var handleSnackbarClose = function (event, reason) {
        if (autoHideDuration !== null || (autoHideDuration === null && reason !== 'clickaway')) {
            onClose === null || onClose === void 0 ? void 0 : onClose(event, reason);
        }
    };
    return (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: jsx_runtime_1.jsx(__1.Snackbar, __assign({ open: internalOpen, onClose: handleSnackbarClose, TransitionProps: {
                exit: false,
            }, anchorOrigin: anchorOrigin || {
                vertical: 'top',
                horizontal: 'center',
            }, autoHideDuration: autoHideDuration }, rest, { children: jsx_runtime_1.jsx(Alert_1.default, __assign({ elevation: 6, variant: "filled", onClose: function (event) { return onClose === null || onClose === void 0 ? void 0 : onClose(event, 'clickaway'); }, severity: severity }, { children: message }), void 0) }), void 0) }, void 0));
}
exports.default = SimpleSnackbar;
//# sourceMappingURL=SimpleSnackbar.js.map